import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import SpinnerComponent from "/components/enhancements/spinner/spinner-component";
import classnames from "classnames";
import { StyledOutlineButtonComponent } from "./outline-button-component.scss";
class OutlineButtonComponent extends PureComponent {
    onClick(e) {
        const { onClickCallback } = this.props;
        if (onClickCallback) {
            onClickCallback(e);
        }
        return true; // continue the location change
    }
    render() {
        const { text, url, theme, buttonStyle, isInScrollMode, linkClassName, loading, onClickCallback } = this.props;
        const scrollModeClass = isInScrollMode ? "scroll-mode" : "";
        return /*#__PURE__*/ _jsx(StyledOutlineButtonComponent, {
            className: classnames("outline-button", theme, buttonStyle, scrollModeClass),
            children: /*#__PURE__*/ _jsxs("a", {
                href: url,
                className: classnames(linkClassName, {
                    loading: loading
                }),
                onClick: this.onClick,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("content", {
                            loading
                        }),
                        children: text
                    }),
                    loading && /*#__PURE__*/ _jsx(SpinnerComponent, {
                        className: "spinner",
                        color: "black",
                        size: "24px",
                        speed: "slow"
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
}
export { OutlineButtonComponent as default };
OutlineButtonComponent.defaultProps = {
    isInScrollMode: false,
    text: "",
    url: undefined,
    theme: "",
    buttonStyle: "default",
    linkClassName: "",
    loading: false
};
